import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useAuth } from "@/hooks/useAuth";
import ErrorBoundary from "@/components/ErrorBoundary";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import AgentDashboard from "@/pages/AgentDashboard";
import AgentDetail from "@/pages/AgentDetail";
import AgentEdit from "@/pages/AgentEdit";
import AgentHistory from "@/pages/AgentHistory";
import MemoryViewer from "@/pages/MemoryViewer";
import Sandbox from "@/pages/Sandbox";
import KBList from "@/pages/KBList";
import KBArticle from "@/pages/KBArticle";
import KBEditor from "@/pages/KBEditor";
import CRMCompanies from "@/pages/CRMCompanies";
import CRMCompanyDetail from "@/pages/CRMCompanyDetail";
import CRMImport from "@/pages/CRMImport";
import CRMCompanyEdit from "@/pages/CRMCompanyEdit";
import CRMIndividualEdit from "@/pages/CRMIndividualEdit";
import CRMFollowups from "@/pages/CRMFollowups";
import Campaigns from "@/pages/Campaigns";
import CampaignDetail from "@/pages/CampaignDetail";
import CampaignEdit from "@/pages/CampaignEdit";
import SuggestionReview from "@/pages/SuggestionReview";
import Backup from "@/pages/Backup";
import DataManagement from "@/pages/DataManagement";
import PMVVEditor from "@/pages/PMVVEditor";
import Schedules from "@/pages/Schedules";
import WorkspaceConnection from "@/pages/WorkspaceConnection";
import MyAssistant from "@/pages/MyAssistant";
import KBIngest from "@/pages/KBIngest";
import FeedbackInbox from "@/pages/FeedbackInbox";
import Finance from "@/pages/Finance";
import Insights from "@/pages/Insights";

export default function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!user) {
    return <Login />;
  }

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Dashboard />} />
            <Route path="/agents" element={<AgentDashboard />} />
            <Route path="/agents/:agentId" element={<AgentDetail />} />
            <Route path="/agents/:agentId/edit" element={<AgentEdit />} />
            <Route path="/agents/:agentId/history" element={<AgentHistory />} />
            <Route path="/agents/:agentId/memory" element={<MemoryViewer />} />
            <Route path="/sandbox" element={<Sandbox />} />
            <Route path="/kb" element={<KBList />} />
            <Route path="/kb/new" element={<KBEditor />} />
            <Route path="/kb/ingest" element={<KBIngest />} />
            <Route path="/kb/:articleId" element={<KBArticle />} />
            <Route path="/kb/:articleId/edit" element={<KBEditor />} />
            <Route path="/crm" element={<CRMCompanies />} />
            <Route path="/crm/import" element={<CRMImport />} />
            <Route path="/crm/companies/new" element={<CRMCompanyEdit />} />
            <Route path="/crm/companies/:companyId" element={<CRMCompanyDetail />} />
            <Route path="/crm/companies/:companyId/edit" element={<CRMCompanyEdit />} />
            <Route path="/crm/individuals/new" element={<CRMIndividualEdit />} />
            <Route path="/crm/individuals/:individualId/edit" element={<CRMIndividualEdit />} />
            <Route path="/crm/followups" element={<CRMFollowups />} />
            <Route path="/campaigns" element={<Campaigns />} />
            <Route path="/campaigns/new" element={<CampaignEdit />} />
            <Route path="/campaigns/:campaignId" element={<CampaignDetail />} />
            <Route path="/campaigns/:campaignId/edit" element={<CampaignEdit />} />
            <Route path="/admin/feedback" element={<FeedbackInbox />} />
            <Route path="/finance" element={<Finance />} />
            <Route path="/insights" element={<Insights />} />
            <Route path="/admin/suggestions" element={<SuggestionReview />} />
            <Route path="/admin/backup" element={<Backup />} />
            <Route path="/admin/data" element={<DataManagement />} />
            <Route path="/my-assistant" element={<MyAssistant />} />
            <Route path="/settings/pmvv" element={<PMVVEditor />} />
            <Route path="/settings/schedules" element={<Schedules />} />
            <Route path="/settings/workspace" element={<WorkspaceConnection />} />
          </Route>
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
}
